import React from 'react'

class VisitedUserPage extends React.Component {
  render() {
    return (
      <div className="shopping-list">
        <p>You have already visited</p>
      </div>
    );
  }
}

export default VisitedUserPage;



// WEBPACK FOOTER //
// ./src/components/general/VisitedUser.js